import axios from "axios"
import authHeader from "./authTokenHeader"
import {API_URL} from "../common/config";

const axiosApi = axios.create({
  baseURL: API_URL,
})

export function refreshToken() {
  axiosApi.defaults.headers.common["Authorization"] = authHeader()
}

export function getHeader() {
  return {
    "Authorization": authHeader(),
  }
}

refreshToken()

axiosApi.interceptors.response.use(response => response, error => Promise.reject(error))

export async function get(url, history, config = {}) {
  return await axiosApi
    .get(url, {...config})
    .then(response => {
      if (response.status >= 200 && response.status <= 299) {
        if (response.data.status === 0) {
          return response.data
        }
      }
      throw response
    })
    .catch(err => {
      throw catchEval(err, history)
    })
}

export async function post(url, history, data, config = {}) {
  return axiosApi
    .post(url, {...data}, {...config})
    .then(response => {
      if (response.status >= 200 && response.status <= 299) {
        if (response.data.status === 0) {
          return response.data
        }
      }
      throw response
    })
    .catch(err => {
      throw catchEval(err, history)
    })
}

export async function put(url, history, data, config = {}) {
  return axiosApi
    .put(url, {...data}, {...config})
    .then(response => {
      if (response.status >= 200 && response.status <= 299) {
        if (response.data.status === 0) {
          return response.data
        }
      }
      throw response
    })
    .catch(err => {
      throw catchEval(err, history)
    })
}

export async function del(url, history, config = {}) {
  return await axiosApi
    .delete(url, {...config})
    .then(response => {
      if (response.status >= 200 && response.status <= 299) {
        if (response.data.status === 0) {
          return response.data
        }
      }
      throw response
    })
    .catch(err => {
      throw catchEval(err, history)
    })
}

export async function patch(url, history, data, config = {}) {
  return axiosApi
    .patch(url, {...data}, {...config})
    .then(response => {
      if (response.status >= 200 && response.status <= 299) {
        if (response.data.status === 0) {
          return response.data
        }
      }
      throw response
    })
    .catch(err => {
      throw catchEval(err, history)
    })
}

export async function download(url, history, filename) {
  axiosApi
    .get(url, {responseType: "blob"})
    .then((response) => {
      const href = URL.createObjectURL(response.data);
      const link = document.createElement("a");

      link.href = href;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(href);
    })
    .catch(err => {
      throw catchEval(err, history)
    })
}

export async function upload(url, history, data, config = {}) {
  return axiosApi
    .post(url, data, {...config})
    .then(response => {
      if (response.status >= 200 && response.status <= 299) {
        if (response.data.status === 0) {
          return response.data
        }
      }
      throw response
    })
    .catch(err => {
      throw catchEval(err, history)
    })
}

const catchEval = (err, history) => {
  if (err.status) {
    switch (err.status) {
      case 403:
        return "No permissions to call this service"
      case 404:
        return "Service could not be found"
      case 500:
        return "Service unavailable"
      case 401:
        history.push("/logout")
        return "Invalid credentials"
      default:
        if (err.data && err.data.message) {
          return err.data.message
        } else {
          return "Undefined error"
        }
    }
  }
  history.push("/logout")
  return "Fatal error"
}